<template>
  <div id="list-dnt">
    <b-overlay :show="isVerifying">
      <div v-if="!isVerifying && !isVerified && !sharedFile.dnt">
        <div class="row mb-3">
          <h5 class="col-12 text-center">
            Por favor ingresa el código de verificación enviado a
            tu correo para poder visualizar el expediente
          </h5>
          <div class="col-4 m-auto">
            <vs-card class=" mt-5">
              <form data-vv-scope="security">
                <vs-input
                    class="w-100"
                    label="Código de verificación"
                    maxlength="10"
                    name="securityPin"
                    v-model="verificationInput"
                    v-validate="'required'"
                    :danger="errors.has('security.verificationInput')"
                    :danger-text="errors.first('security.verificationInput')"
                />
                <div class="text-center">
                  <vs-button
                      color="warning"
                      class="mt-4"
                      @click="verifyFile"
                  >
                    Verificar
                  </vs-button>
                </div>
              </form>
            </vs-card>
          </div>
        </div>
      </div>
      <div v-if="!isVerifying && sharedFile.dnt">
    <div class="row">
    <div class="col-6">
      <PdfViewport
          ref="pdfViewport"
          :default-page="1"
          :s3url="selectedFile.url"
          name="hola"
      />
    </div>
    <div class="col-6 bg-white mb-5">
    <div class="text-center">
      <img
          :src="logo"
          alt="logo"
          class=" cursor-pointer logo-ed"
      />
    </div>
    <h5
        class="mt-3"
        style="color:#7a008d;"
    >
      Este expediente <span v-if="sharedFile.dnt.claseMercadoPublico === 'int'">
                interno
              </span> <span v-if="sharedFile.dnt.claseMercadoPublico === 'ext'">
                externo
              </span> <span v-if="sharedFile.dnt.claseMercadoPublico === 'numInt'">
                de numeración interna
              </span> <span v-if="sharedFile.dnt.claseMercadoPublico === 'numOf'">
                de numeración oficial
              </span> ha sido creado por {{ sharedFile.dnt.solicitanteNombre }}
      <small>{{ sharedFile.dnt.solicitanteEmail }}</small>
      , perteneciente a la unidad {{ sharedFile.dnt.solicitanteGrupoNombre }}
    </h5>
    <div class="py-2">
      - Te han compartido el documento {{ sharedFile.dnt.emisorCentroCostoNombre }}
      <span v-if="sharedFile.dnt.emisorSucursalDireccion">
                {{ sharedFile.dnt.emisorSucursalDireccion }}
              </span> <span v-if="sharedFile.dnt.numeroInt">
                número {{ sharedFile.dnt.numeroInt }}
              </span> <span v-if="sharedFile.dnt.fechaEmision">
                con fecha {{ sharedFile.dnt.fechaEmision }}
              </span> <span
        class="py-2"
        v-if="sharedFile.dnt.condicionDespacho
                && sharedFile.dnt.condicionDespacho.toString() === '0'"
    >
                de formato papel
              </span> <span
        class="py-2"
        v-if="sharedFile.dnt.condicionDespacho
                && sharedFile.dnt.condicionDespacho.toString() === '1'"
    >
                de formato electrónico
              </span>
    </div>

    <div
        class="py-2"
        v-if="sharedFile.dnt.compradorArea"
    >
      De origen: {{ sharedFile.dnt.compradorArea }} <span v-if="sharedFile.dnt.emisorContactoArea">
                - {{ sharedFile.dnt.emisorContactoArea }}
              </span>
    </div>
    <div
        class="py-2"
        v-if="sharedFile.dnt.emisorContactoNombre"
    >
      - Persona Remitente: {{ sharedFile.dnt.emisorContactoNombre }}
      <span v-if="sharedFile.dnt.emisorContactoEmail">
        {{ sharedFile.dnt.emisorContactoEmail }}
      </span>
      <span
        class="py-2"
        v-if="sharedFile.dnt.emisorContactoCargo"
      >
      con el cargo de {{ sharedFile.dnt.emisorContactoCargo }}
      </span>
    </div>

    <div
        class="py-2"
        v-if="sharedFile.dnt.transporteNotas"
    >
      - Detalle: {{ sharedFile.dnt.transporteNotas }}
    </div>
    <div
        class="py-2"
        v-if="sharedFile.dnt.transporteViaTransporteCodigoTransporte
         && sharedFile.dnt.transporteViaTransporteCodigoTransporte.toString() === '0'"
    >
      - No acompaña material físico
    </div>
    <div
        class="py-2"
        v-if="sharedFile.dnt.transporteViaTransporteCodigoTransporte
        && sharedFile.dnt.transporteViaTransporteCodigoTransporte.toString() === '1'"
    >
      - Acompaña material físico
    </div>
    <div v-if="sharedFile.observaciones[0]">
      - Observaciones: {{ sharedFile.observaciones[0].observacion }}
    </div>
    <div v-if="sharedFile.observaciones[1]">
      - Materia: {{ sharedFile.observaciones[1].observacion }}
    </div>
    <div class="mt-5 mb-5">
      <h5>
        Destinos / Copias
      </h5>
      <vs-table
          class="wrap-table-large"
          stripe
          :data="(sharedFile.destinatarios || [])"
          noDataText="No hay destinatarios"
      >
        <template slot="header">
        </template>
        <template slot="thead">
          <vs-th>
            Nombre
          </vs-th>
          <vs-th>
            Tipo
          </vs-th>
          <vs-th>
            Alcance
          </vs-th>
        </template>

        <template>
          <tbody>
          <vs-tr
              v-for="(subject, index) in (sharedFile.destinatarios || [])"
              :key="index"
          >
            <vs-td>
              {{ subject.destinoListaNombre }} <small
                class="d-block"
                v-if="externalSubject.includes(subject.destinoCodigo)"
            > {{ subject.destinoCorreo }} </small>
            </vs-td>
            <vs-td>
              {{ subject.destinoNombre }}
            </vs-td>
            <vs-td>
              <vs-chip
                  color="primary"
                  v-if="subject.tipoDestino.toString() === '1'"
              >
                Destinatario
              </vs-chip>
              <vs-chip
                  color="#43C3B9"
                  v-if="subject.tipoDestino.toString() === '2'"
              >
                En copia
              </vs-chip>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <!--<Timeline
        :timeline-items="fileCommentDetails.ejecucion.comentarios"
        message-when-no-items="No hay comentarios"/>-->
    </div>
    <hr>
    <div class=" mt-5 mb-5">
      <h5>
        Referencias
      </h5>
      <vs-table
          class="wrap-table"
          stripe
          :data="(sharedFile.referencias || [])"
          noDataText="No hay otros documentos relacionados"
      >
        <template slot="header">
        </template>
        <template slot="thead">
          <vs-th>
            Tipo Documento
          </vs-th>
          <vs-th>
            Número
          </vs-th>
        </template>

        <template>
          <tbody v-if="!isSiss">
          <vs-tr v-if="sharedFile.dnt.transportePuertoCodigo">
            <vs-td>
              Contrato SAFI
            </vs-td>
            <vs-td>
              {{ sharedFile.dnt.transportePuertoCodigo }}
            </vs-td>
          </vs-tr>
          <vs-tr
              v-for="reference in (sharedFile.referencias || [])"
              :key="reference.dntReferenciaId"
          >
            <vs-td>
              {{ findTypeDocument(reference.tipoDocumento) }}
            </vs-td>
            <vs-td>
              {{ reference.folio }}
            </vs-td>
          </vs-tr>
          </tbody>
          <tbody v-if="isSiss">
          <vs-tr
              v-for="reference in (sharedFile.referencias || [])"
              :key="reference.dntReferenciaId"
          >
            <vs-td>
              {{ findLabelDocument(reference.tipoDocumento) }}
            </vs-td>
            <vs-td>
              {{ reference.folio }}
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <hr>
    <div class=" mt-5 mb-5">
      <h5>
        Archivos adjuntos
      </h5>
      <vs-table
          class="wrap-table"
          stripe
          :data="(sharedFile.adjuntos || [])"
          noDataText="No hay archivos adjuntos"
      >
        <template slot="header">
        </template>
        <template slot="thead">
          <vs-th v-if="isConvention">
            Nombre documento
          </vs-th>
          <vs-th>
            Nombre Adjunto
          </vs-th>
          <vs-th>
            Tipo
          </vs-th>
          <vs-th>
            Ver
          </vs-th>
        </template>
        <template>
          <tbody>
          <vs-tr
              v-for="attachment in sharedFile.adjuntos"
              :key="attachment.adjuntoId"
          >
            <vs-td v-if="isConvention">
              {{ attachment.tipoDescripcion || '-' }}
            </vs-td>
            <vs-td>
                      <span v-if="attachment.adjuntoNombre">
                        {{ attachment.adjuntoNombre }}
                      </span> <span v-if="attachment.nombre">
                        {{ attachment.nombre }}
                      </span>
            </vs-td>
            <vs-td>
              {{ attachment.tipo }}
            </vs-td>
            <vs-td>
                      <span
                          v-tooltip="'Ver archivo'"
                          v-on:click="getFile(attachment)"
                          style="cursor:pointer;width: fit-content;"
                      >
                        <vs-icon
                            icon="description"
                            size="small"
                            :title="attachment.nombre"
                        />
                      </span> <span
                v-tooltip="'Descargar archivo'"
                v-on:click="downloadFile(attachment)"
                style="cursor:pointer;width: fit-content;"
            >
                        <vs-icon
                            icon="attachment"
                            size="small"
                            :title="attachment.nombre"
                        />
                      </span>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    </div>
    </div>
    </div>
    </b-overlay>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindExternalTypeDocumentMixin';
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindExternalLabelDocumentMixin';

export default {
  mixins: [FindTypeDocumentMixin, FindLabelDocumentMixin],
  components: { PdfViewport },
  data() {
    const { view } = this.$route.params;
    return {
      logo: require('../../../../assets/images/ed-logo.png'),
      verificationInput: '',
      isVerified: false,
      isVerifying: true,
      view,
      selectedFile: {},
      externalSubject: [
        'empresas',
        'personas',
        'ministerios',
        'sanitarias'
      ]
    };
  },
  watch: {
    sharedFile() {
      if (this.sharedFile.dnt) {
        this.isVerified = true;
        this.getFile(this.sharedFile.adjuntos[0]);
      }
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-dnt > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#list-dnt',
        scale: 0.6
      });
    },
    successAction() {
      this.$vs.notify({
        title: 'Genial!',
        text: 'Acción realizada exitosamente',
        color: 'success',
        time: 3000,
        position: 'top-center'
      });
    },
    error(error) {
      if (error !== '') {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Código de verificación erroneo',
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'allDocumentsState'
    ]),
    ...mapGetters('Dnts', [
      'loading',
      'error',
      'successAction',
      'files'
    ]),
    ...mapGetters('Usuario', [
      'verificationCode',
      'sharedFile',
      'error'
    ]),
    ...mapGetters('Empresas', ['company']),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isSiss() {
      return this.sharedFile && this.sharedFile.dnt.emisorRut === '61221000-4';
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchAllDocumentsExternRequest'
    ]),
    ...mapActions('Dnts', [
      'listDocuments',
      'clearErrorMessage',
      'selectFileState'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Usuario', [
      'ioGetFileCodeVerification',
      'verifySharedFile'
    ]),
    getFile(attachment) {
      this.selectedFile = attachment;
    },
    downloadFile(attachment) {
      window.open(attachment.url, '_blank');
    },
    verifyFile() {
      this.verifySharedFile({
        id: this.verificationCode,
        codigo: this.verificationInput
      });
    },
    findLabel(document) {
      return this.allDocumentsState.list.find((option) => option.value === document) || {};
    }
  },
  created() {
    try {
      const domain = window.location.href.replace('https://', '').replace('http://', '').split('/');
      this.fetchAllDocumentsExternRequest({
        dominio: domain[0],
        grupoOpcion: 'tipos.documentos-ed',
        agrupar: 'si'
      });
      const { id } = this.$route.params;
      const { idSubject } = this.$route.params;
      const response = this.ioGetFileCodeVerification(
        {
          tipo: 'expediente_externo',
          febosId: id,
          destinoId: idSubject
        }
      );
      if (response.dnt) {
        this.isVerified = true;
      }
      setTimeout(() => {
        this.isVerifying = false;
      }, 1000);
    } catch (e) {
      setTimeout(() => {
        this.isVerifying = false;
      }, 1000);
    }
  }
};
</script>
<style>
.logo-ed {
  width: 400px;
  height: auto;
}
</style>
